<template>
  <div class="agent-settlement">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-left">
            <el-select
              v-if="isStaff"
              v-model="filters.agentUserId"
              clearable
              filterable
              placeholder="选择代理"
              class="filter-item agent-select"
              :loading="agentLoading"
            >
              <el-option
                v-for="item in agentOptions"
                :key="item.userId"
                :label="formatAgentLabel(item)"
                :value="item.userId"
              />
            </el-select>
            <el-date-picker
              v-model="filters.dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="结算日起"
              end-placeholder="结算日止"
              class="filter-item"
              clearable
            />
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </div>
          <div v-if="isStaff" class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加结算</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && list.length === 0" description="暂无结算记录" />

      <div v-else>
        <el-table
          :data="list"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载..."
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="70" align="center" />
          <el-table-column v-if="isStaff" label="代理" min-width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.agentNickname || '—' }}</div>
              <div class="sub-text">{{ scope.row.agentPhone || ('UID ' + scope.row.agentUserId) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="结算区间" min-width="200" align="center">
            <template slot-scope="scope">
              {{ formatSettleRange(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="amountYuan" label="金额(元)" width="120" align="center" />
          <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" width="170" align="center" />
          <el-table-column v-if="isStaff" label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      v-if="isStaff"
      :title="isEdit ? '编辑结算记录' : '添加结算记录'"
      :visible.sync="dialogVisible"
      width="520px"
      append-to-body
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="代理" prop="agentUserId">
          <el-select
            v-model="form.agentUserId"
            filterable
            placeholder="请选择代理"
            style="width: 100%"
            :loading="agentLoading"
          >
            <el-option
              v-for="item in agentOptions"
              :key="item.userId"
              :label="formatAgentLabel(item)"
              :value="item.userId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="结算区间" prop="settleRange">
          <el-date-picker
            v-model="form.settleRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="金额" prop="amountYuan">
          <el-input-number
            v-model="form.amountYuan"
            :min="0.01"
            :step="1"
            :precision="2"
            controls-position="right"
            style="width: 100%"
          />
          <div class="form-tip">单位：元</div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model.trim="form.remark"
            type="textarea"
            :rows="2"
            maxlength="255"
            show-word-limit
            placeholder="可选"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, getResponseMessage } from '@/utils/http.js'

export default {
  name: 'AgentSettlementManagement',
  data() {
    return {
      loading: false,
      submitting: false,
      agentLoading: false,
      error: '',
      list: [],
      agentOptions: [],
      filters: {
        agentUserId: null,
        dateRange: null
      },
      pagination: { page: 1, pageSize: 20, total: 0 },
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: this.emptyForm(),
      rules: {
        agentUserId: [{ required: true, message: '请选择代理', trigger: 'change' }],
        settleRange: [{ required: true, message: '请选择结算区间', trigger: 'change' }],
        amountYuan: [{ required: true, message: '请填写金额', trigger: 'blur' }]
      }
    }
  },
  computed: {
    role() {
      const v = parseInt(localStorage.getItem('role'), 10)
      return Number.isNaN(v) ? -1 : v
    },
    isStaff() {
      return this.role === 0 || this.role === 1
    },
    isAgent() {
      return this.role === 2
    }
  },
  mounted() {
    if (this.isStaff) {
      this.loadAgents()
    }
    this.fetchList()
  },
  methods: {
    emptyForm() {
      return {
        agentUserId: null,
        settleRange: null,
        amountYuan: 0.01,
        remark: ''
      }
    },
    formatAgentLabel(item) {
      const name = item.nickname || '未命名'
      const phone = item.phone || ('UID ' + item.userId)
      return `${name}（${phone}）`
    },
    formatSettleRange(row) {
      if (!row.settleStartDate) return '—'
      if (!row.settleEndDate || row.settleEndDate === row.settleStartDate) {
        return row.settleStartDate
      }
      return `${row.settleStartDate} 至 ${row.settleEndDate}`
    },
    async loadAgents() {
      this.agentLoading = true
      try {
        const res = await get('/admin/agent/page', {
          page: 1,
          pageSize: 500
        })
        const data = res.data || {}
        this.agentOptions = data.records || []
      } catch (e) {
        this.agentOptions = []
        this.$message.error(getResponseMessage(e) || e.message || '加载代理失败')
      } finally {
        this.agentLoading = false
      }
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        if (this.isStaff && this.filters.agentUserId != null) {
          params.agentUserId = this.filters.agentUserId
        }
        if (this.filters.dateRange && this.filters.dateRange.length === 2) {
          params.startDate = this.filters.dateRange[0]
          params.endDate = this.filters.dateRange[1]
        }
        const url = this.isAgent
          ? '/admin/agent-settlement/my/page'
          : '/admin/agent-settlement/page'
        const res = await get(url, params)
        const data = res.data || {}
        this.list = data.records || []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.list = []
        this.error = e.message || '加载失败'
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.filters = { agentUserId: null, dateRange: null }
      this.pagination.page = 1
      this.fetchList()
    },
    handleAdd() {
      this.isEdit = false
      this.editId = null
      this.form = this.emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = {
        agentUserId: row.agentUserId,
        settleRange: [row.settleStartDate, row.settleEndDate],
        amountYuan: Number(row.amountYuan),
        remark: row.remark || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (!this.form.settleRange || this.form.settleRange.length !== 2) {
          this.$message.warning('请选择结算区间')
          return
        }
        this.submitting = true
        try {
          const payload = {
            agentUserId: this.form.agentUserId,
            settleStartDate: this.form.settleRange[0],
            settleEndDate: this.form.settleRange[1],
            amountYuan: this.form.amountYuan,
            remark: this.form.remark || null
          }
          if (this.isEdit) {
            await put(`/admin/agent-settlement/${this.editId}`, payload)
            this.$message.success('更新成功')
          } else {
            await post('/admin/agent-settlement', payload)
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '保存失败')
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      const label = `${row.agentNickname || row.agentPhone || row.agentUserId} / ${this.formatSettleRange(row)} / ${row.amountYuan}元`
      this.$confirm(`确定删除结算记录「${label}」吗？`, '提示', { type: 'warning' })
        .then(async () => {
          try {
            await del(`/admin/agent-settlement/${row.id}`)
            this.$message.success('已删除')
            this.fetchList()
          } catch (e) {
            this.$message.error(getResponseMessage(e) || e.message || '删除失败')
          }
        })
        .catch(() => {})
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.agent-settlement {
  padding: 0;
}
.filter-card {
  margin-bottom: 16px;
}
.filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.filter-item {
  width: 240px;
}
.agent-select {
  width: 260px;
}
.form-tip {
  margin-top: 4px;
  color: #94a3b8;
  font-size: 12px;
}
.sub-text {
  color: #94a3b8;
  font-size: 12px;
}
.muted {
  color: #94a3b8;
}
.danger-text {
  color: #ef4444;
}
.error {
  color: #ef4444;
  margin-bottom: 12px;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
</style>
